
import { defineComponent, PropType } from 'vue'
import { iScorecardTarget, iScorecardCriterion, iKpi } from '../Scorecards'
import { getSelectedCriteriaTooltip, getKpiIconColorClass, getSelectedCriteria } from '../ScorecardsHelpers'
import MultiSelect from 'primevue/multiselect'
import SelectButton from 'primevue/selectbutton'
import descriptor from './ScorecardsTableDescriptor.json'
import ScorecardsTableHint from './ScorecardsTableHint.vue'
import ScorecardsKpiDialog from '../ScorecardsKpiDialog/ScorecardsKpiDialog.vue'

export default defineComponent({
    name: 'scorecards-target-item',
    components: { MultiSelect, SelectButton, ScorecardsTableHint, ScorecardsKpiDialog },
    props: { propTarget: { type: Object as PropType<iScorecardTarget> }, criterias: { type: Array as PropType<iScorecardCriterion[]>, required: true }, kpis: { type: Array as PropType<iKpi[]>, required: true } },
    emits: ['deleteTarget', 'openKpiDialog', 'touched'],
    data() {
        return {
            descriptor,
            target: null as iScorecardTarget | null,
            expanded: false,
            selectedCriteria: 'M',
            kpiDialogVisible: false,
            getSelectedCriteriaTooltip,
            getKpiIconColorClass
        }
    },
    watch: {
        propTarget() {
            this.loadTarget()
        }
    },
    async created() {
        this.loadTarget()
    },
    methods: {
        loadTarget() {
            this.target = this.propTarget as iScorecardTarget
            if (this.target.name === 'New Target') this.expanded = true
            this.selectedCriteria = getSelectedCriteria(this.target.criterion?.valueCd)
        },
        onCriteriaChange() {
            if (!this.target) return
            for (let i = 0; i < this.criterias.length; i++) {
                if ((this.selectedCriteria === 'M' && this.criterias[i].valueCd === 'MAJORITY') || (this.selectedCriteria === 'MP' && this.criterias[i].valueCd === 'MAJORITY_WITH_PRIORITY') || (this.selectedCriteria === 'P' && this.criterias[i].valueCd === 'PRIORITY')) {
                    this.target.criterion = this.criterias[i]
                    this.$emit('touched', true)
                    this.target.updated = true
                    break
                }
            }
        },
        openKpiDialog() {
            this.kpiDialogVisible = true
        },
        onKpiSelected(selectedKpis: iKpi[]) {
            if (this.target) {
                this.target.kpis = selectedKpis
                this.$emit('touched', true)
                this.target.updated = true
                this.expanded = true
            }
            this.kpiDialogVisible = false
        },
        deleteKpiConfirm(kpi: iKpi) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteConfirmTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.deleteKpi(kpi)
            })
        },
        async deleteKpi(kpi: iKpi) {
            if (!this.target) return
            const index = this.target.kpis.findIndex((tempKpi: iKpi) => tempKpi.id === kpi.id)
            if (index !== -1) {
                this.target.kpis.splice(index, 1)
                if (this.target.criterion.valueCd !== 'MAJORITY') {
                    const index = this.target.options.criterionPriority.findIndex((criteria: string) => criteria === kpi.name)
                    if (index !== -1) this.target.options.criterionPriority.splice(index, 1)
                }
                this.$emit('touched', true)
                this.target.updated = true
            }
        },
        deleteTargetConfirm() {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteConfirmTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.$emit('deleteTarget', this.target)
            })
        },
        onCriterionPriortyChanged() {
            this.$emit('touched', true)
            if (this.target) this.target.updated = true
        }
    }
})
